import React from 'react';
import { Form, Checkbox, Input, Select } from 'antd';

const InputGroup = Input.Group;
const { Option } = Select;

export default function TotalDetalle(props) {
    return (
        <div className="row">
            <div className={"col-md-6"}>
                
            </div>
            <div className="col-md-3 form-group">
                
            </div>
            <div className="col-md-3 pt-10">
                
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Sub Total</label>
                        <div>{props.onGetFieldValue('sumaSubTotal').toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>IGV</label>
                        <div>{props.onGetFieldValue('sumaIgv').toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Total</label>
                        <div>{props.onGetFieldValue('sumaTotal').toFixed(2)}</div>
                    </div>
                </div>
                
            </div>
        </div>
    );
}